// @flow

import type {Action} from '../../types'
import type {HospitalState} from '../types'
import type {SetLoadingPayload} from '../actions/setLoading'

export function setLoadingReducer(state: HospitalState, action: Action<SetLoadingPayload>): HospitalState {

  return {
    ...state,
  }
}
